import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, createSystem, defaultConfig } from '@chakra-ui/react'
import App from './App';

// Chakra v3 wraps its resets, tokens and recipe styles in CSS cascade layers
// (@layer), supported only from Firefox 97 / Chrome 99. The older Firefox/ESR
// build used in the IVV environment (the same one missing structuredClone,
// see polyfills.js) drops every layered rule, which strips all design tokens
// and component styles and badly deforms the UI. Emitting the same styles
// unlayered renders identically in modern browsers and restores old ones.
const system = createSystem(defaultConfig, { disableLayers: true });

const root = ReactDOM.createRoot(document.getElementById('root'));

fetch(`${process.env.PUBLIC_URL}/config.json`)
  .then((response) => response.json())
  .then((config) => {
    // Attach it to the global window object so it's accessible anywhere
    window.APP_CONFIG = config;

    // render app after config loaded
    root.render(
      <React.StrictMode>
        <ChakraProvider value={system}>
          <App />
        </ChakraProvider>
      </React.StrictMode>,
    );
  })
  .catch((error) => {
    console.error("Failed to load runtime configuration!", error);
    // fallback if config is missing
    document.getElementById('root').innerHTML = `
      <div style="padding: 20px; color: red; font-family: sans-serif;">
        <h2>Configuration Error</h2>
        <p>Could not load application configuration.</p>
      </div>
    `;
  });